<template>
  <b-card>
    <b-row>
      <b-col cols="12" sm="6">
        <label>{{ $t('Form.Start Date') }}</label>
        <flat-pickr v-model="start" :config="config" class="form-control" type="date" />
      </b-col>
      <b-col cols="12" sm="6">
        <label>{{ $t('Form.End Date') }}</label>
        <flat-pickr v-model="end" :config="config" class="form-control" type="date" />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="12" sm="10" v-if="advanced">
        <label>Facilities</label>
        <treeselect
          v-model="facility"
          class="rounded"
          style="background: #fff"
          :options="facilityOptions"
          :multiple="true"
          :clearable="true"
          :disabled="facilityOptions.length === 1"
          :normalizer="normalizer"
          :value-format="facilityOptions.length === 1 ? 'object' : 'id'" />
      </b-col>
      <b-col cols="12" sm="2" align-self="end">
        <b-button :disabled="isLoading" class="mt-3 w-100" variant="primary" @click="buscar">
          <span v-if="!isLoading">Search</span>
          <b-spinner small v-else label="Loading..."></b-spinner>
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BCol, BRow, BButton, BSpinner } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BCard,
    BCol,
    BRow,
    flatPickr,
    BButton,
    BSpinner,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
    advanced: {
      type: Boolean,
      default: false,
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      start: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`,
      end: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
      config: {
        dateFormat: 'Y-m-d',
        allowInput: true,
        minDate: this.advanced
          ? false
          : `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`,
        maxDate: this.advanced
          ? false
          : `${new Date().getFullYear()}-${new Date().getMonth() + 2}-1`,
      },
      facilityOptions: [],
      facility: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
    }
  },
  methods: {
    buscar() {
      this.$emit('buscar', {
        start: this.start,
        end: this.end,
        facilities: this.facility,
      })
    },
  },
  mounted() {
    this.facilityOptions = JSON.parse(atob(localStorage.getItem('setFacilityOptions')))
    // Eliminamos la búsqueda automática: this.buscar();
  },
}
</script>

<style lang="scss" scoped>
.button {
  position: absolute;
  left: 90%;
  top: 5%;
}

// Responsive improvements
@media (max-width: 575px) {
  .card-body {
    padding: 1rem;
  }
  
  .row {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
  
  .col, [class*="col-"] {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  
  .mt-3 {
    margin-top: 1rem !important;
  }
  
  label {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
  
  .form-control {
    font-size: 0.9rem;
    padding: 0.5rem 0.75rem;
  }
  
  .btn {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
}

@media (max-width: 480px) {
  .card-body {
    padding: 0.75rem;
  }
  
  .row {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }
  
  .col, [class*="col-"] {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  
  label {
    font-size: 0.85rem;
  }
  
  .form-control {
    font-size: 0.85rem;
    padding: 0.4rem 0.6rem;
  }
  
  .btn {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
}

// Ensure proper spacing on very small screens
@media (max-width: 360px) {
  .card-body {
    padding: 0.5rem;
  }
  
  .mt-3 {
    margin-top: 0.75rem !important;
  }
}
</style>
